import { PartialStateUpdater, patchState, signalState } from '@ngrx/signals';
import { Signal } from '@angular/core';
import { StateBase } from 'src/app/shared/state/hashmap-state-base';
import { AccountUi } from '../../models/account.model';

export interface StateManager extends StateBase {
  account: Signal<AccountUi | null>;
  loading: Signal<boolean>;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  error: Signal<any>;
  setAccount: (account: AccountUi | null) => void;
  setLoading: (loading: boolean) => void;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setError: (error: any) => void;
}

export function accountsStateFactory(): StateManager {
  return new AccountsBaseState();
}

interface State {
  account: AccountUi | null;
  loading: boolean;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  error: any;
}

const defaultState: State = {
  account: null,
  loading: false,
  error: null,
};

class AccountsBaseState implements StateManager {
  private readonly accountState = signalState<State>(defaultState);

  public readonly account = this.accountState.account;
  public readonly loading = this.accountState.loading;
  public readonly error = this.accountState.error;
  private _lastModified: number = -1;

  public get lastModified(): number {
    return this._lastModified;
  }

  setAccount(account: AccountUi | null): void {
    this._lastModified = Date.now();
    patchState(this.accountState, this.accountSetter(account));
  }

  setLoading(loading: boolean): void {
    patchState(this.accountState, this.loadingSetter(loading));
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setError(error: any): void {
    patchState(this.accountState, this.errorSetter(error));
  }

  private accountSetter(
    account: AccountUi | null
  ): PartialStateUpdater<{ account: State['account'] }> {
    return () => {
      return {
        account,
      };
    };
  }

  private loadingSetter(
    loading: boolean
  ): PartialStateUpdater<{ loading: boolean }> {
    return () => ({ loading });
  }

  private errorSetter(error: boolean): PartialStateUpdater<{ error: boolean }> {
    return () => ({ error });
  }
}
